import React, { Component } from 'react';
import { Card } from 'react-bootstrap';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

import * as util from '../../library/utilitys';
import * as charts from '../../library/charts';
import Loading from './Loading';

ChartJS.register(
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip,
    Legend,
    ChartDataLabels
);

class DashboardVerticalBarChart extends Component {
    render() {
        const { data, title, icon, bg = 'primary', cardWrap = true, stacked = false, suggestedMaxY = 0, suggestedMinY = 0, chartHeight = 400 } = this.props;

        const resolvedHeight =
            typeof chartHeight === 'number'
                ? `${chartHeight}px`
                : chartHeight;

        const colors = charts.getChartColors();
        const labels = data?.labels || [];
        const datasets = data?.datasets || [];
        const hasData = labels.length > 0 && datasets.length > 0;

        const chartData = {
            labels,
            datasets: datasets.map((ds, index) => ({
                ...ds,
                backgroundColor: colors[index % colors.length]
            }))
        };

        const valuesByLabel = labels.map((_, labelIndex) =>
            datasets.reduce((sum, ds) => {
                const val = Number(ds.data?.[labelIndex]) || 0;
                return stacked ? sum + val : Math.max(sum, val);
            }, 0)
        );

        const maxValue = Math.max(...valuesByLabel, 0);
        const minValue = Math.min(...valuesByLabel, 0);

        const suggestedMax =
            Math.ceil((maxValue + suggestedMaxY) / 10) * 10;

        const suggestedMin =
            Math.floor((minValue - suggestedMinY) / 10) * 10;

        const options = {
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                legend: {
                    position: 'bottom'
                },
                // tooltip: {
                //     callbacks: {
                //         label: ctx => util.formatNumber(ctx.raw)
                //     }
                // },
                tooltip: {
                    callbacks: {

                        // หัว tooltip
                        title: (items) => {
                            return items[0].dataset.label;
                        },

                        // ค่า
                        label: (ctx) => {
                            return util.formatNumber(ctx.raw);
                        }
                    }
                },
                datalabels: {
                    anchor: stacked ? 'center' : 'end',
                    align: stacked ? 'center' : 'top',
                    color: stacked ? '#fff' : '#333',
                    formatter: value => util.formatNumber(value),
                    font: {
                        size: 10
                    }
                }
            },
            scales: {
                x: {
                    stacked,
                    grid: { display: false }
                },
                y: {
                    stacked,
                    beginAtZero: true,
                    max: suggestedMax,
                    min: suggestedMin < 0 ? suggestedMin : 0,
                    grid: { display: false }
                }
            }
        };


        const chartContent = (
            <div style={{ height: resolvedHeight }}>
                {hasData ? (
                    <Bar data={chartData} options={options} />
                ) : (
                    <Loading height={resolvedHeight} variant="primary" />
                )}
            </div>
        );

        return cardWrap ? (
            <Card className="card-border mb-0">
                <Card.Header className={`card-header-action bg-${bg}`}>
                    <h6 className="text-white">
                        {icon && <i className={`${icon} me-2`} />}
                        {title}
                    </h6>
                </Card.Header>

                <Card.Body style={{ height: resolvedHeight }}>
                    {chartContent}
                </Card.Body>
            </Card>
        ) : chartContent
    }
}

export default DashboardVerticalBarChart;
